<!-- galerija-o-nama.html - ✅ POPRAV LJENO -->
<section id="galerija" class="netflix-gallery">
  <!-- Hero Statement -->
  <div class="gallery-hero">
    <div class="hero-content">
      <h2 class="hero-title">Autentični ambijent Kockice</h2>
      <p class="hero-text">
        Drveni detalji, toplina roštilja, priče koje se prenose generacijama. 
        Svaki kutak krije uspomenu.
      </p>
    </div>
  </div>

  <!-- Netflix Horizontal Scroll Gallery -->
  <div class="netflix-carousel" #carousel>
    <div class="carousel-track" #carouselTrack>
      
      <!-- 1. Srce restorana -->
      <div class="netflix-card" style="--delay: 0.1s">
        <div class="card-image">
          <img src="unutrasnjost10.jpeg" alt="Kockica ambijent" loading="lazy">
          <div class="card-overlay">
            <h3>Srce restorana</h3>
            <p>Dobrodošli u domaću toplinu gdje roštilj priča svoje priče.</p>
          </div>
        </div>
      </div>

      <!-- 2. Autentična atmosfera -->
      <div class="netflix-card" style="--delay: 0.2s">
        <div class="card-image">
          <img src="unutrasnjost2.jpeg" alt="Unutrašnjost detalj 1" loading="lazy">
          <div class="card-overlay">
            <h3>Zašto Kockica?</h3>
            <p>Autentičan roštilj.</p><p>Prava atmosfera.</p><p> Sretni gosti.</p>
          </div>
        </div>
      </div>

      <!-- 3. Intimni kutci -->
      <div class="netflix-card" style="--delay: 0.3s">
        <div class="card-image">
          <img src="unutrasnjost3.jpeg" alt="Unutrašnjost detalj 2" loading="lazy">
          <div class="card-overlay">
            <h3>Intimni kutci</h3>
            <p>Mjesto za poslovne razgovore ili porodične trenutke.</p>
          </div>
        </div>
      </div>

      <!-- 4. Toplina tradicije -->
      <div class="netflix-card" style="--delay: 0.4s">
        <div class="card-image">
          <img src="unutrasnjost4.jpeg" alt="Unutrašnjost detalj 3" loading="lazy">
          <div class="card-overlay">
            <h3>Toplina tradicije</h3>
            <p>Drveni detalji koji nose duh generacija dobrog gostoprimstva.</p>
          </div>
        </div>
      </div>

      <!-- 5. Ljetna bašta -->
      <div class="netflix-card" style="--delay: 0.5s">
        <div class="card-image">
          <img src="unutrasnjost5.jpeg" alt="Kockica terasa" loading="lazy">
          <div class="card-overlay">
            <h3>Ljetna bašta</h3>
            <p>Savršena terasa za ljetne večeri.</p>
          </div>
        </div>
      </div>
      
    </div> 
  </div> 
</section>
